import {getListingName} from "@hosttools/core/shared/utils/utils.listing";
import {CloseIcon, memoWithType} from "@hosttools/frontend";
import {ButtonIconTooltip, HStack, ListingChannelsLogo, Text} from "@hosttools/frontend/components";
import {useCallback} from "react";

import type {LockListing} from "./type";

type Props<T extends LockListing> = {
    item: T;
    onRemove?: (item: T) => void;
};

function LockListingItem<T extends LockListing>({item, onRemove}: Props<T>) {
    const handleDelete = useCallback(() => {
        onRemove?.(item);
    }, [item, onRemove]);

    return (
        <HStack className="items-center bg-primary-100 rounded-xs p-1 max-w-full" space="sm">
            {"isLock" in item ? null : (
                // use icon from Seam api is more correct so temporarily disable lock icon
                // <Icon as={buildChannel(item.source).LogoCircle} />
                <ListingChannelsLogo listing={item} />
            )}
            <Text isTruncated className="shrink grow" variant="sm">
                {"isLock" in item ? item.name : getListingName(item)}
            </Text>
            {onRemove && (
                <ButtonIconTooltip
                    icon={CloseIcon}
                    size="sm"
                    tooltip="Remove"
                    onPress={handleDelete}
                />
            )}
        </HStack>
    );
}

export default memoWithType(LockListingItem);
